// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { GlobalValidator } from "../../types";

import {
  createValidator,
  getBinding,
} from "#stdnum-runtime";

const btcbase58: GlobalValidator = createValidator(
  "crypto.btcbase58",
  41,
);

export default btcbase58;
export const compact = btcbase58.compact;
export const format = btcbase58.format;
export const validate = btcbase58.validate;
export const decodeBase58 = (
  value: string,
): Uint8Array | null => getBinding().decodeBase58(value);
